import { LocationPage } from './../location/location';
import { Eczane } from './../../_models/eczane';
import { EczaneService } from './../../_services/eczane.service';
import { Component } from '@angular/core';
import { NavController, ModalController, LoadingController } from 'ionic-angular';
import { Location } from './../../_models/location';
import { Geolocation } from '@ionic-native/geolocation';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  eczaneler: Eczane[];
  markers: Location[] = [];
  showMap: boolean;

  currentLatitude: Number;
  currentLongitude: Number;

  constructor(public navCtrl: NavController,
    private eczaneService: EczaneService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private geolocation: Geolocation
   ) {
     this.geolocation.getCurrentPosition().then((resp) => {
      this.currentLatitude = resp.coords.latitude;
      this.currentLongitude = resp.coords.longitude;
      console.log(resp.coords.latitude, resp.coords.longitude);
     }).catch((error) => {
       console.log('Error getting location', error);
     });

    this.getNobetciEczaneler();
  }

  getNobetciEczaneler() {
    const loader = this.loadingCtrl.create({
      content: "Yükleniyor...",
      duration: 3000
    });
    loader.present();

    this.eczaneService.getPlaylists().subscribe((eczaneler: Eczane[]) => {
      this.eczaneler = eczaneler;
      this.eczaneler.forEach(area => {
        this.markers.push({name: area.ad, 
          adres: area.adres, 
          latitude: +area.lat, 
          longitude: +area.lng, 
          iconUrl: 'assets/imgs/eczane.png', 
          strokeColor: 'red',
          currentLatitude: this.currentLatitude,
          currentLongitude: this.currentLongitude
        })
      });
      loader.dismiss();
    }, error => console.log(error));
  }

  changeView(toggleView) {
    this.showMap = toggleView.checked
  }

  onOpenMap(lat, lng, eczane) {
    const modal = this.modalCtrl.create(LocationPage, {
      latitude: lat, 
      longitude: lng, 
      locationName: eczane.ad,
      adres: eczane.adres,
      iconUrl: 'assets/imgs/eczane.png',
      currentLatitude: this.currentLatitude,
      currentLongitude: this.currentLongitude
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts